
<!-- 资源详情页面 -->
 <!-- 面试题库详情页面 -->
<template>
  <div>
    <span id="spanData">
      <el-card class="box-card">
        <!-- 使用table标签布局 -->
        <table>
          <!-- 设置标题 -->
          <tr>
            <th colspan="2">
              <h1 id="h1Title">{{ respContentData.resourceName }}</h1>
            </th>
          </tr>
          <!-- 设置标题信息 -->
          <tr>
            <th colspan="2">
              <el-tag id="tag1" type="info">
                <!-- 用户名 -->
                <span style="color: black; font-size: small">
                  {{
                    respContentData.userData.nickName != null
                      ? respContentData.userData.nickName
                      : respContentData.userData.userName
                  }}
                </span>
                <!-- 创建时间 -->
                <span style="margin-left: 20px">
                  <i class="el-icon-time"></i>
                  于&nbsp;&nbsp;{{
                    respContentData.createtime
                  }}&nbsp;&nbsp;上传 </span
                ><br />
                <!-- 文章标签 -->
                <span>
                  文章标签:
                  <el-tag
                    size="mini"
                    style="margin-left: 10px"
                    v-for="(item, index) in respContentData.dynamicTagList"
                    :key="index"
                  >
                    {{ item }}
                  </el-tag>
                </span>
              </el-tag>
            </th>
          </tr>
          <!-- 立即下载行 -->
          <tr>
            <td>
              <el-button
                style="border-radius: 15px; margin-left: 10px"
                type="warning"
                plain
                @click="resourceDownLoad()"
                >立即下载</el-button
              >
            </td>
          </tr>

          <!-- 设置内容 -->
          <tr>
            <td colspan="2">
              <el-card shadow="always" style="height: 500px">
                <div v-html="respContentData.resourceDescription"></div>
              </el-card>
            </td>
          </tr>
        </table>
      </el-card>
    </span>

    <!-- 积分购买提示弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <span>是否花费：{{ needPriceData.price }} 积分</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goDetails2(needPriceData.price)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
     
    
    <script>
// 导入封装好的发送请求类
import {
  contentWhetherNeedPrice,
  priceAmple,
  updatePriceAmple,
  findResDetailsByResId,
  getReqFileUrl,
} from "@/api/resourceDownLoad/resourceDownLoad.js";
export default {
  data() {
    return {
      respContentData: {}, //响应回来的内容数据
      dialogVisible: false, //控制是否积分购买弹窗

      // 是否需要积分购买弹出数据
      needPriceData: {},
      // 点击确定，积分是否充足
      ampleData: {},
    };
  },

  //   一进入页面执行
  created() {
    // 获取内容信息
    this.findResourceDetailsByResId();
  },
  computed: {
    // 获取传递过来的bankId
    gainResourceId() {
      return this.$route.params.resourceId;
    },
    // 获取当地登录用户id
    getUserId() {
      // 获取用户id,应该是当前登录用户的userId
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      return userData.data.userId;
    },
  },

  methods: {
    // 查询资源详情,通过resourceId
    async findResourceDetailsByResId() {
      const resourceId = this.gainResourceId;
      // 调用查询详情接口
      const res = await findResDetailsByResId(resourceId);
      this.respContentData = res.data;
      console.log("获取响应数据：" + JSON.stringify(this.respContentData));
    },

    // 点击立即下载调用方法
    resourceDownLoad() {
      // 获取resourceId
      const resourceId = this.respContentData.resourceId;
      // 调用校验方法
      this.goDetails(resourceId);
    },

    // 点击立即下载，需要判断当前资源是否需要积分
    async goDetails(resourceId) {
      // 获取用户id
      const userId = this.getUserId;
      console.log("跳转到了详情页面方法:" + resourceId + "userId:" + userId);
      // 调用方法判断内容是否需要积分
      const needPrice = {
        resourceId: resourceId,
        userId: userId,
      };
      const res = await contentWhetherNeedPrice(needPrice);
      this.needPriceData.needState = res.data.needState;
      this.needPriceData.price = res.data.price;
      this.needPriceData.resourceId = resourceId;

      // 如果需要积分，则进行弹窗
      if (res.data.needState === 1) {
        this.dialogVisible = true;
      } else {
        // 当前资源不需要积分，或者当前用户已经买过的资源，可以直接下载
        this.getFileUrl(resourceId);
      }
    },

    // 弹框后，点击确定后， 进行页面跳转
    async goDetails2(price) {
      // 设置弹窗状态为false
      this.dialogVisible = false;

      // 调用接口，判断当前用户积分是否充足，充足则进行跳转，不充足，进行提示
      this.ampleData.needPrice = price;
      this.ampleData.resourceId = this.needPriceData.resourceId;
      this.ampleData.userId = this.getUserId;

      const resData = await updatePriceAmple(this.ampleData);
      console.log("获取判断的数据为：" + JSON.stringify(resData));
      // 根据返回数据的priceState字段值进行判断，1积分充足，0积分不充足
      if (resData.data.priceState === 0) {
        // 积分不充足，进行提示
        this.$message({
          showClose: true,
          message: "积分不充足,当前剩余积分：" + resData.data.userNewPrice,
          type: "warning",
        });
      } else {
        // 积分充足，进行下载
        this.getFileUrl(this.ampleData.resourceId);

        // 更改本地缓存中的积分值为当前用户最新的积分值
        const userData = JSON.parse(localStorage.getItem("accessUserData"));
        userData.data.pricePo.price = resData.data.userNewPrice;
        // 将更改后的值重新设置进去
        localStorage.setItem("accessUserData", JSON.stringify(userData));

        // 强制刷新整个页面
        setTimeout(() => {
          window.location.reload();
        }, 1000); // 1秒后刷新页面
        
      }
    },

    // 通过resourceId获取fileUrl，进行下载方法
    async getFileUrl(resourceId) {
      const res = await getReqFileUrl(resourceId);
      // 获取资源下载地址
      const fileUrl = "https://" + res.data;
      const a = document.createElement("a");
      a.href = fileUrl;
      a.download = fileUrl.split("/").pop(); // 你可以根据需要设置文件名
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};
</script>
  
    <style scoped>
/* 设置标题内容样式 */
#tag1 {
  width: 100%;
  height: auto;
}

/* 标题样式 */
#h1Title {
  text-align: center;
}

/* 布局table样式 */
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  /* border: 1px solid #000; */
  padding: 8px;
  text-align: left;
}

/* 外围span标签样式 */
#spanData {
  display: flex;
  justify-content: center;
}
/* 外围card样式 */
.box-card {
  width: 70%;
}
</style>